import React from 'react'
import { Col, Row } from 'react-bootstrap'
import NumberFormat from 'react-number-format'
import './headerDetails.css'
import { HEADER_DETAILS_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'

export default function FundTransferHeaderDetails({ option = {} }) {
  const { t } = useTranslation()
  return (
    <div className='approval-card-header '>
      <span>
        <span className='span1'>
          {t(HEADER_DETAILS_KEYS.ACCOUNT_NO)}. : {option?.destAcc}{' '}
        </span>
        <span className='mt-2 span2'>{option?.beneName} </span>
      </span>
      <span>
        <span className=' '>
          <span className='d-flex span3'>
            {option?.destCurrency} &nbsp;{' '}
            <NumberFormat
              value={option?.amount}
              displayType={'text'}
              thousandSeparator={true}
              prefix={''}
              className='span3'
              fixedDecimalScale={true}
              decimalScale={2}
              allowEmptyFormatting
            />
          </span>
        </span>
        <span className='mt-2 span2 text-right'>
          {option?.initDate !== null ? option?.initDate : '-'}
        </span>
      </span>
    </div>
  )
}
